import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { SERVICES } from "../data/content";

export default function Services() {
  return (
    <main data-testid="services-page" className="bg-[#070C14] text-white">
      <PageHero
        testId="services-hero"
        eyebrow="Services & solutions"
        title="Consulting, procurement, contracting, environment, trading."
        description="A connected service architecture for energy, oil and gas, environment, and maritime clients operating in complex African and global markets."
        image="/assets/page_7_img_3.jpeg"
        imageAlt="Industrial pipes and fittings"
      />

      <section data-testid="services-grid-section" className="mx-auto max-w-7xl px-4 py-20 sm:px-8 lg:px-10 lg:py-28">
        <div className="grid gap-6 lg:grid-cols-2">
          {SERVICES.map((service, index) => {
            const Icon = service.icon;
            return (
              <Reveal key={service.slug} delay={index * 0.06}>
                <Link
                  to={`/services/${service.slug}`}
                  data-testid={`service-card-${service.slug}`}
                  className="group grid min-h-[360px] overflow-hidden rounded-3xl border border-white/10 bg-[#0D131F] transition-all duration-500 hover:-translate-y-2 hover:border-blue-400/40 md:grid-cols-[.9fr_1.1fr]"
                >
                  <div className="relative min-h-56 overflow-hidden">
                    <img src={service.image} alt={service.title} className="absolute h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                    <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#0D131F]/50" />
                  </div>
                  <div className="flex flex-col justify-between p-8">
                    <div>
                      <div className="flex items-center justify-between">
                        <Icon className="text-amber-400" size={26} />
                        <span className="font-mono text-xs text-blue-400">0{index + 1}</span>
                      </div>
                      <h2 className="mt-8 font-heading text-3xl font-semibold">{service.title}</h2>
                      <p className="mt-4 text-sm leading-7 text-slate-400">{service.summary}</p>
                    </div>
                    <div className="mt-8 flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-amber-300">
                      Open practice <ArrowUpRight size={16} className="transition-transform group-hover:rotate-45" />
                    </div>
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </section>
    </main>
  );
}
